var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactFormFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contact-form-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-Contact-detail",
    transform: "translate(-290.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-contact-form-fill",
    transform: "translate(290.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#6F7FE2",
    x: 0.444444444,
    y: 0.444444444,
    width: 15.1111111,
    height: 15.1111111,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.555556, 3.111111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#FFFFFF",
    x: 0.444444444,
    y: 2.22222222,
    width: 8,
    height: 1.77777778,
    rx: 0.888888889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#FFFFFF",
    x: 0.444444444,
    y: 7.55555556,
    width: 8,
    height: 1.77777778,
    rx: 0.888888889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#090B45",
    x: 0,
    y: 5.33333333,
    width: 7.11111111,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#090B45",
    x: 0,
    y: 0,
    width: 7.11111111,
    height: 1,
    rx: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactFormFill);
export default __webpack_public_path__ + "static/media/icon-contact-form-fill.43ab33bd832535c15d00af6c4eb92b65.svg";
export { ForwardRef as ReactComponent };